import { Component, DestroyRef, inject, Input, signal } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AgActionIconButtonComponent } from "@shared/components/grid/ag-cells/common/ag-action-icon-button/ag-action-icon-button.component";
import { ButtonComponent, IBtnColor } from "@shared/controls/button/button.component";
import { Observable, of, take } from "rxjs";

export interface IActionButtonConfig {
  text: string;
  iconClass?: string;
  btnColor?: IBtnColor;
  action: Observable<unknown>;
}

export interface ICommonActionModalConfig {
  header: string;
  iconClass?: string;
  body?: string;
  showCloseBtn?: boolean;
  closeBtnWrapperClass?: string;
  closeBtnText?: string;
  actions: IActionButtonConfig[];
  cancelAction?: Observable<unknown>
}

@Component({
  selector: 'app-common-actions-modal',
  standalone: true,
  imports: [
    AgActionIconButtonComponent,
    ButtonComponent,
  ],
  templateUrl: 'common-actions-modal.component.html',
  styleUrl: 'common-actions-modal.component.scss'
})
export class CommonActionsModalComponent {
  private activeModal = inject(NgbActiveModal);
  private destroyRef = inject(DestroyRef);

  @Input() config!: ICommonActionModalConfig;

  isLoading = signal<boolean>(false);

  performAction(action: Observable<unknown>): void {
    this.isLoading.set(true);
    action
      .pipe(take(1))
      .subscribe({
        next: (result) => this.activeModal.close(result),
        error: () => this.isLoading.set(false)
      });
  }

  cancel(): void {
    const cancelAction = this.config.cancelAction ?? of(null);
    this.isLoading.set(true);

    cancelAction
      .pipe(take(1))
      .subscribe({
        next: (result) => this.activeModal.dismiss(result),
        error: () => this.activeModal.dismiss()
      });
  }

  close(): void {
    this.activeModal.dismiss(true);
  }

  getDestroyRef(): DestroyRef {
    return this.destroyRef;
  }
}
